import React from 'react';
import Hero from '../components/sections/Hero';
import ValueForAgents from '../components/sections/ValueForAgents';
import ValueForAgencies from '../components/sections/ValueForAgencies';
import TransitionCTA from '../components/sections/TransitionCTA';
import AgencyShowcase from '../components/sections/AgencyShowcase';
import AboutPreview from '../components/sections/AboutPreview';
import CarriersPreview from '../components/sections/CarriersPreview';

const Home: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-white">
      <div className="relative min-h-screen">
        <Hero />
        <AgencyShowcase />
        <ValueForAgents />
        <TransitionCTA />
        <ValueForAgencies />
        <AboutPreview />
        <CarriersPreview />
      </div>
    </div>
  );
};

export default Home;